import { hexToRGBA } from 'src/utils/all';
import { TMenuColors } from './types';
import { TBurgerMenu } from './components/burger-menu/types';

type Result = Record<keyof TMenuColors, string>;

export const DEFAULT_COLORS = {
  bg: '#000000',
  hover: '#000000',
  text: '#ffffff',
  open: '#000000',
  search: '#ffffff',
  scrollbar: '#2055FF',
  btnBg: '#2055FF',
  btnHover: '#ffffff',
  btnText: '#ffffff',
  iotBg: '#000000',
  bmBg: '#000000',
  iotText: '#ffffff',
  bmText: '#ffffff',
};

export const DEFAULT_SETTINGS = {
  alwaysOpen: false,
  tooltipOnBm: false,
  tooltipOnIot: false,
  search: true,
  categoryExpand: false,
  transparent: true,
  fullScreenMobile: true,
  openOnHoverBm: false,
  openOnHoverIot: false,
  openOnLaunch: false,
};

export const getColor = (color: string, defaultColor: string) => {
  if (color && color !== '#ffffff' && color !== '#fff') {
    return color;
  }

  return defaultColor;
};

export function getColors(colors: TMenuColors, transparent: boolean) {
  const color = (c: string, d: string) => hexToRGBA(getColor(c, d), transparent ? 0.8 : 1);
  const result: Result = {} as Result;

  for (const key in colors) {
    result[key] = color(colors[key], DEFAULT_COLORS[key]);
  }

  return result;
}

export function extractSlug(url) {
  const lastSlashIndex = url.lastIndexOf('/');
  const endOfString = url.length - 1;

  if (lastSlashIndex === -1 || endOfString === -1 || endOfString <= lastSlashIndex) {
    return null;
  }

  const slug = url.substring(lastSlashIndex + 1, endOfString);
  return slug;
}

export const filterMenuItems = (menus: TBurgerMenu[], search: string) => {
  if (!search) return menus;

  const subStr: string = search.toLowerCase();
  const filterMenus = (menus: TBurgerMenu[]) => {
    if (menus.length === 0) return [];

    return menus.filter((m: TBurgerMenu) => {
      if (m.title.toLowerCase().includes(subStr)) {
        return true;
      }
      if (m.subSubMenus) {
        m.subSubMenus = filterMenus(m.subSubMenus);
      } else if (m.subMenus) {
        m.subMenus = filterMenus(m.subMenus);
      }
      return (
        m.title.toLowerCase().includes(subStr) ||
        m.subMenus?.length > 0 ||
        (m.subSubMenus || []).length > 0
      );
    });
  };
  const clone = JSON.parse(JSON.stringify(menus));
  return filterMenus(clone);
};

export const getParentIds = (items: TBurgerMenu[], id: number) => {
  let menuId: number | null = null;
  let subMenuId: number | null = null;
  let subSubMenuId: number | null = null;

  items.forEach((menu) => {
    if (menu.id === id) {
      menuId = id;
    } else {
      menu.subMenus.forEach((subMenu) => {
        if (subMenu.id === id) {
          menuId = menu.id;
          subMenuId = id;
        } else {
          subMenu.subSubMenus?.forEach((subSubMenu) => {
            if (subSubMenu.id === id) {
              menuId = menu.id;
              subMenuId = subMenu.id;
              subSubMenuId = id;
            }
          });
        }
      });
    }
  });

  return { menuId, subMenuId, subSubMenuId };
};
